import { ActivityFragment } from '@spotify/confidence-graphql';
import {
  ISSUE_ACTIVITY_TYPES,
  TASK_ACTIVITY_TYPES,
} from '@spotify/plugin-confidence-issues-react';

export const isActivityType = (
  activity: ActivityFragment,
  typeId: string,
): boolean => activity.name.startsWith(`activityTypes/${typeId}/`);

export const isIssueActivityType = (
  activity: ActivityFragment,
  typeId: (typeof ISSUE_ACTIVITY_TYPES)[keyof typeof ISSUE_ACTIVITY_TYPES],
): boolean => isActivityType(activity, typeId);

export const isTaskActivityType = (
  activity: ActivityFragment,
  typeId: (typeof TASK_ACTIVITY_TYPES)[keyof typeof TASK_ACTIVITY_TYPES],
): boolean => isActivityType(activity, typeId);
